import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { trigger, state, style } from '@angular/animations';
import { Subscription } from 'rxjs';
import { UserRole } from '@classes/licence/user-role';
import { LicenceService } from '@services/licence.service';

@Component({
    selector: 'app-roles-list',
    templateUrl: './roles-list.component.html',
    styleUrls: ['./roles-list.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*' }))
        ])
    ]
})
export class RolesListComponent implements OnInit, OnDestroy {
    @Input() rolesList: UserRole[];
    @Input() isEditAllowed: boolean;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    private selectedLicenceSub: Subscription;

    displayedColumns: string[] = ['role', 'quotas'];
    dataSource: MatTableDataSource<UserRole>;

    editedCode: string;
    isCreationMode: boolean;
    isLoading: boolean;

    constructor(
        private licenceSrv: LicenceService
    ) { }

    ngOnInit() {
        this.initTable();
        this.initSubscriptions();
    }

    onEdit(code?: string): void {
        this.isCreationMode = !code;
        this.editedCode = code;
    }

    onDelete(code: string): void {
        this.isLoading = true;
        this.licenceSrv.deleteRole(code)
        .subscribe(
            () => this.isLoading = false,
            () => this.isLoading = false
        );
    }

    onEditFinished(): void {
        this.editedCode = null;
        this.isCreationMode = false;
    }

    private initTable(): void {
        if(this.isEditAllowed) {
            this.displayedColumns.push('actions');
        }
        this.dataSource = new MatTableDataSource(this.rolesList);
        this.sortTable();
    }

    private initSubscriptions(): void {
        this.selectedLicenceSub = this.licenceSrv.selectedLicenceChanged
        .subscribe(licence => {
            this.dataSource.data = licence ? licence.roles : [];
            this.sortTable();
            this.onEditFinished();
        });
    }

    private sortTable(): void {
        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'role': return item.text.shortLabel.toLowerCase();
                case 'quotas': return item.userQuota.value;
                default: return item[property];
            }
        };
        this.dataSource.sort = this.sort;
    }

    ngOnDestroy() {
        if(this.selectedLicenceSub) {
            this.selectedLicenceSub.unsubscribe();
        }
    }
}
